export default "__VITE_ASSET__BgwsVQQm__"